import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "px-2 border-r-2 border-grey w-48" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, " Be sure to set correct 'active' project in your User monitor to access Participants from that project ", -1 /* HOISTED */)
const _hoisted_4 = { class: "mt-4 font-serious" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Current project: ")
const _hoisted_6 = { class: "mt-4 flex flex-col text-left" }
const _hoisted_7 = { class: "flex flex-col flex-grow" }
const _hoisted_8 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_9 = {
  key: 1,
  class: "font-serious"
}
const _hoisted_10 = { class: "m-2" }
const _hoisted_11 = ["id", "onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex flex-col flex-grow py-4 text-left m-2 overflow-y-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Game Details", -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "font-bold text-sm"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectionBox = _resolveComponent("SelectionBox")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!
  const _component_MonitorParticipantMastery = _resolveComponent("MonitorParticipantMastery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("strong", null, _toDisplayString(_ctx.userProject.projectName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SelectionBox, {
          id: "select-locationfilter",
          modelValue: _ctx.selectedGroup,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroup) = $event)),
          label: 'Filter by location',
          options: _ctx.groupList,
          class: "m-2",
          onChange: _ctx.filterGamesByGroup
        }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
        _createVNode(_component_AnswerInput, {
          "boolean-value": _ctx.masteryOnly,
          "onUpdate:boolean-value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.masteryOnly) = $event)),
          class: "m-2",
          mode: "binaryChoice",
          border: false,
          label: "Only Participants with Mastery Sets"
        }, null, 8 /* PROPS */, ["boolean-value"]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.masteryOnly)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "'Mastery Set' Participants, for selected location & project"))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "Participants by selected user, project & location")),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (g, i) => {
              return (_openBlock(), _createElementBlock("li", {
                id: `li-participant-${g._id}`,
                key: 'ap-' + i,
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.selectGame(g))
              }, [
                (_ctx.selectedGame && g._id === _ctx.selectedGame._id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "✔︎ "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13)),
                _createTextVNode(" " + _toDisplayString(g.name), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_11))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      (_ctx.masteryOnly)
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Showing only data for 'Mastery' baseline and probes"))
        : _createCommentVNode("v-if", true),
      (_ctx.selectedGame._id && _ctx.cmsRoot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_MonitorParticipantMastery, {
              game: _ctx.selectedGame,
              cmsroot: _ctx.cmsRoot,
              results: _ctx.results,
              class: "w-full"
            }, null, 8 /* PROPS */, ["game", "cmsroot", "results"])
          ]))
        : _createCommentVNode("v-if", true),
      _hoisted_18
    ])
  ]))
}